// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_horizontalOptions__sShCK {
  height: 3rem;
  display: flex;
  flex-direction: row-reverse; }
  .styles_horizontalOptions__sShCK > button svg {
    transition: 1s all;
    transform: rotate(90deg);
    padding: unset; }
  .styles_horizontalOptions__sShCK > div {
    display: flex;
    flex-direction: row-reverse;
    width: 0rem;
    overflow: hidden;
    transition: 1s all;
    align-items: center;
    overflow-x: scroll; }
  .styles_horizontalOptions__sShCK.styles_open__6KlaU > button svg {
    transform: rotate(0deg); }
  .styles_horizontalOptions__sShCK.styles_open__6KlaU > div {
    width: 90%; }
    .styles_horizontalOptions__sShCK.styles_open__6KlaU > div button svg {
      padding: 0rem 1rem;
      max-height: 90%; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/ExpandableOptions/HorizontalOptions/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAY;EAeZ,aAAa;EACb,2BAA2B,EAAA;EAjB7B;IAGI,kBAAkB;IAClB,wBAAwB;IACxB,cAAc,EAAA;EALlB;IAQI,aAAa;IACb,2BAA2B;IAC3B,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB,EAAA;EAdtB;IAoBM,uBAAuB,EAAA;EApB7B;IAuBM,UAAU,EAAA;IAvBhB;MA0BQ,kBAAkB;MAClB,eAAe,EAAA","sourcesContent":[".horizontalOptions {\n  height: 3rem;\n  & > button svg {\n    transition: 1s all;\n    transform: rotate(90deg);\n    padding: unset;\n  }\n  & > div {\n    display: flex;\n    flex-direction: row-reverse;\n    width: 0rem;\n    overflow: hidden;\n    transition: 1s all;\n    align-items: center;\n    overflow-x: scroll;\n  }\n  display: flex;\n  flex-direction: row-reverse;\n  &.open {\n    & > button svg{\n      transform: rotate(0deg);\n    }\n    & > div {\n      width: 90%;\n\n      & button svg {\n        padding: 0rem 1rem;\n        max-height: 90%;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"horizontalOptions": `styles_horizontalOptions__sShCK`,
	"open": `styles_open__6KlaU`
};
export default ___CSS_LOADER_EXPORT___;
